// extracted by mini-css-extract-plugin
export default {"container":"Header_container__ovr55","title":"Header_title__8MwtL","header":"Header_header__8jyjd","arrow":"Header_arrow__+qQbG","desc":"Header_desc__0GSOk"};